import { render, staticRenderFns } from "./historyactive.vue?vue&type=template&id=05cfd193&"
import script from "./historyactive.vue?vue&type=script&lang=js&"
export * from "./historyactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports